import React from 'react';
import { motion } from 'framer-motion';
import { FaCheck, FaCrown, FaPaperPlane } from "react-icons/fa";
import TopNavbarre from '../composants/topnavbarre';
import Footer from '../composants/footer';
import header from '../asset/2.png';
import { Link } from "react-router-dom";

const tarifs = [
  {
    titre: "CAMPUS FRANCE",
    prix: "149.900 FCFA",
    services: [
      "Choix des établissements et formations",
      "Préparation aux entretiens",
      "Suivi jusqu'à l'obtention du visa",
    ],
    highlight: false,
    icon: <FaPaperPlane className="text-2xl" />,
  },
  {
    titre: "BOURSEs D'ÉTUDEs",
    prix: "170.000 FCFA",
    services: [
      "Choix du pays et de l'établissement",
      "Candidature aux programmes de bourses",
      "Conception de CV & lettre de motivation",
      "Engagement dans des démarches d’obtention de bourses",
      "Suivi jusqu'à la réponse finale",
    ],
    highlight: true,
    icon: <FaCrown className="text-2xl" />,
  },
];

// Animation variants
const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0 },
};

const Tarifs = () => {
  const handleScroll = (e) => {
    e.preventDefault();
    const nextSection = document.getElementById('content');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div>
      <section className="relative bg-cover bg-center h-screen flex flex-col">
        {/* Image de fond avec overlay */}
        <div 
          className="absolute inset-0 bg-black/30 bg-blend-darken"
          style={{
            backgroundImage: `url(${header})`,
            backgroundPosition: 'center 30%',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
          }}
        ></div>

        {/* Navbar */}
        <TopNavbarre/>
        
        {/* Contenu principal centré verticalement */}
        <div className="relative z-10 flex-grow flex items-center justify-center text-center">
          <div className="mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl lg:max-w-4xl">
              {/* Titre principal avec animation */}
              <motion.h1 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="text-2xl sm:text-2xl md:text-2xl lg:text-3xl font-bold text-white leading-tight mb-2 sm:mb-4"
              >
                Des offres<span className="text-blue-400"> claires  et accéssibles</span>
              </motion.h1>
              
              {/* Sous-titre */}
              <motion.p 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3, duration: 0.8 }}
                className="text-base sm:text-lg md:text-xl text-gray-100 mb-6 sm:mb-8 max-w-lg"
              >
                Des solutions adaptées à chaque projet d'études à l'international
              </motion.p>
              
              {/* Groupe de boutons - Taille réduite sur mobile */}
              <motion.div 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6, duration: 0.8 }}
                className="flex flex-col sm:flex-row gap-3 sm:gap-4"
              >
                <Link
                  to="/contact"
                  className="bg-blue-600 hover:bg-blue-700 text-white font-semibold 
                            px-4 py-2 sm:px-6 sm:py-2.5 md:px-8 md:py-3 
                            rounded-lg shadow-lg transition-all duration-300 
                            transform hover:-translate-y-1 text-sm sm:text-base mx-auto block text-center"
                >
                  Garantis ton avenir
                </Link>
              </motion.div>
            </div>
          </div>
        </div>
        
        {/* Indicateur de défilement - Taille réduite sur mobile */}
        <div className="absolute bottom-6 sm:bottom-8 left-1/2 transform -translate-x-1/2 z-10">
          <motion.a 
            href="#content" 
            className="animate-bounce inline-block"
            onClick={handleScroll}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <svg className="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
            </svg>
          </motion.a>
        </div>
      </section>

      {/* Section Tarification */}
      <section className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <span className="inline-block bg-white/20 text-white px-4 py-2 rounded-full text-sm font-medium mb-4">
              Nos Offres
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Tarifs <span className="text-blue-200">Transparents</span>
            </h2>
            <p className="text-lg text-blue-100 max-w-3xl mx-auto">
              Des solutions adaptées à chaque projet d'études à l'international
            </p>
          </motion.div>

          {/* Tarifs */}
          <motion.div
            initial="hidden"
            whileInView="show"
            variants={container}
            viewport={{ once: true, margin: "-100px" }}
            className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12"
          >
            {tarifs.map((offre, index) => (
              <motion.div
                key={index}
                variants={item}
                whileHover={{ y: -5 }}
                className={`relative ${offre.highlight ? "lg:-mt-4" : ""}`}
              >
                {offre.highlight && (
                  <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-yellow-400 text-blue-900 px-4 py-1 rounded-full text-xs font-bold uppercase tracking-wide shadow-md">
                    Plus Populaire
                  </div>
                )}
                <div
                  className={`h-full bg-white rounded-xl shadow-lg overflow-hidden border-2 ${
                    offre.highlight
                      ? "border-blue-400 shadow-xl"
                      : "border-white/20"
                  }`}
                >
                  <div className="p-8 flex flex-col h-full">
                    <div className="flex items-center justify-center mb-4">
                      <div
                        className={`p-4 rounded-full ${
                          offre.highlight
                            ? "bg-blue-600 text-white"
                            : "bg-blue-100 text-blue-600"
                        }`}
                      >
                        {offre.icon}
                      </div>
                    </div>
                    <h3 className="text-center uppercase font-bold text-gray-800 mb-2 tracking-wider">
                      {offre.titre}
                    </h3>
                    <div className="text-center mb-6">
                      <span className="text-3xl font-bold text-blue-600">
                        {offre.prix}
                      </span>
                    </div>

                    <ul className="space-y-3 mb-8 flex-grow">
                      {offre.services.map((service, i) => (
                        <li key={i} className="flex items-start">
                          <FaCheck
                            className={`flex-shrink-0 mt-1 mr-3 ${
                              offre.highlight
                                ? "text-blue-600"
                                : "text-gray-400"
                            }`}
                          />
                          <span className="text-gray-700">{service}</span>
                        </li>
                      ))}
                    </ul>

                    <Link
                      to="/contact" // Redirige vers la page contact
                      className={`w-full py-3 px-6 rounded-lg font-semibold text-center transition-all block ${
                        offre.highlight
                          ? "bg-blue-600 text-white hover:bg-blue-700"
                          : "bg-white text-blue-600 border-2 border-blue-600 hover:bg-blue-50"
                      }`}
                    >
                      Contact
                    </Link>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>

          {/*plus d'info */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            viewport={{ once: true }}
            className="mt-16 text-center text-blue-100 text-sm"
          >
            <p>
              * Tous nos tarifs incluent un accompagnement complet jusqu'à
              l'obtention de votre visa.
            </p>
            <p className="mt-2">
              Besoin d'une solution personnalisée ? Contactez-nous pour un devis
              sur mesure.
            </p>
          </motion.div>
        </div>
      </section>

      <Footer/>
    </div>
  );
};

export default Tarifs;